import { render, staticRenderFns } from "./ArticlePostCard.vue?vue&type=template&id=4f7aed81&"
import script from "./ArticlePostCard.vue?vue&type=script&lang=js&"
export * from "./ArticlePostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports